import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";

import useCsrStateLevel from "./hooks/useCsrStateLevel";

const CsrStateLevel = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData,
}) => {
  const csrStateLevelData = useCsrStateLevel(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={csrStateLevelData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {csrStateLevelData.screen_title} -{" "}
          <span className="heading-cod">{csrStateLevelData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={csrStateLevelData.formFields}
        dropdownValues={csrStateLevelData.dropdownValues}
        paramsData={csrStateLevelData.paramsData}
        updataParamData={csrStateLevelData.updateParamData}
      />
      <ButtonsSection ctaButtons={csrStateLevelData.ctaButtons} />
      <DisplayTable
        data={csrStateLevelData.data}
        parmKey={csrStateLevelData.parmKey}
        menuOptions={csrStateLevelData.menuOptions}
        tableHeaders={csrStateLevelData.columnDef}
        setRowData={csrStateLevelData.setRowData}
        selectedPriceSchedules={csrStateLevelData.selectedRows}
        setSelectedPriceSchedules={csrStateLevelData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={csrStateLevelData.first}
          rows={csrStateLevelData.rows}
          totalRecords={csrStateLevelData.totalRecords}
          currentPage={csrStateLevelData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={csrStateLevelData.onPageChange}
        />
      </div>
      {csrStateLevelData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={csrStateLevelData.isConfirmationModalOpen}
          onRequestClose={csrStateLevelData.closeConfirmationModal}
          onBack={csrStateLevelData.closeConfirmationModal}
          onSave={csrStateLevelData.deleteCSRStateLevel}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={csrStateLevelData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default CsrStateLevel;
